import { Button, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { WebSocketContext } from "../../../../../../Providers/WebSocket/WebSocketContext"
import { useContext, useState } from "react"
import { EncomendaContex } from "../../../../../../Providers/EncomendaContext/EncomendaContext"
import OneModal from "../../../../../../Components/OneModal/OneModal"
import { showNotify } from "../../../../../../Utils/Utils"
import { UserContext } from "../../../../../../Providers/UserContext/UserContex"
import OneTextArea from "../../../../../../Components/OneTextArea/OneTextArea"
import { container, containerObs, textArea } from "./ModalConfirmacaoChegouEntrega"

const ModalConfirmacaoChegouEntrega = ({ setOpen, id_encomenda }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { procurarEncomenda } = useContext(EncomendaContex)
    const { user } = useContext(UserContext)
    const [formData, setFormData] = useState(null)

    const AlterarTipoEncomenda = (msg) => {
        let dados = msg.data
        if (dados.status != 'error') {
            setOpen(false)
            procurarEncomenda()
        } else {
            showNotify("warning", `Erro ao confirmar o recebemento da encomenda!`)
        }
    }

    const handleChange = (event) => {
        if (event.target.value !== undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleSubmitSim = () => {
        let obj = {
            recebedor_encomenda_futura: user.id,
            id: id_encomenda,
            nome_quem_baixou: user.nome,
            observacao_recebedor: ''
        }

        if (formData && formData.observacao_recebedor) {
            obj.observacao_recebedor = formData.observacao_recebedor
        }

        sendWs("AlterarTipoEncomenda", obj)
        addRoute("AlterarTipoEncomenda", AlterarTipoEncomenda)
    }

    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            titleText={'Confirmar '}
            FooterButtons={() => footerButtons(setOpen, handleSubmitSim)}
        >
            <Grid sx={container}>

                <Grid sx={containerObs}>
                    <Grid>
                        <Typography>Observação de Recolhimento:</Typography>
                    </Grid>
                    <Grid sx={textArea}>
                        <OneTextArea
                            name="observacao_recebedor"
                            onChange={handleChange}
                        ></OneTextArea>
                    </Grid>
                </Grid>
                <Grid>
                    <Typography sx={{ fontWeight: 500 }}>Confirma o recebemento da encomenda?</Typography>
                </Grid>
            </Grid>

        </OneModal >
    )
}

function footerButtons(setOpen, handleSubmitSim) {
    return (
        <Grid container xs={12} sx={{ justifyContent: 'space-between', width: '100%' }}>
            <Button color="success" variant="contained" onClick={ handleSubmitSim }> Sim </Button>
            <Button color="error" variant="contained" onClick={() => setOpen(false)} > Não </Button>
        </Grid >
    )
}

export default ModalConfirmacaoChegouEntrega
